import AdvancedSearch from '@nile/components/src/Components/AdvancedSearch/AdvancedSearch';
import {
  onAttributeSelect,
  onValueSearch
} from '@nile/components/src/Pebbles/AdvancedTicketFilter';
import {
  onAttributeSelect as onFilterSelect,
  onValueSearch as onFilterSearch
} from '@nile/components/src/Pebbles/CsatAdvancedFilter';
import {
  onAlertAttributeSelect,
  onAlertAttributeValueSearch
} from '@nile/rmm/src/modules/alert-management/services/alert-advanced-filter-helper';
import {
  onAssetViewAttributeSelect,
  onAssetViewAttributeValueSearch
} from '@nile/rmm/src/modules/asset-management/services/asset-view-advanced-filter-helper';
import {
  onPatchViewAttributeSelect,
  onPatchViewAttributeValueSearch
} from '@nile/rmm/src/modules/patch-management/services/patch-advanced-filter-helper';
import {
  onAttributeSelect as onClientAttributeSelect,
  onValueSearch as onClientAttributeSearch
} from '@nile/components/src/Pebbles/AdvancedClientRequesterFilter';
import { onInvoiceViewAttributeSelect } from '@nile/components/src/Pebbles/AdvancedInvoiceFilter';
import {
  onOfferedItemAttributeSelect,
  onOfferedItemAttributeSearch
} from '@nile/components/src/Pebbles/AdvancedOfferedItemFilter';
import {
  onWorklogEntrySelect,
  onWorklogEntrySearch
} from '@nile/components/src/Pebbles/AdvancedWorklogEntryFilter';
import React from 'react';
import { injectIntl } from 'react-intl';

function ReportQueryBuilderForm(props) {
  const { currentModule } = props;

  const newBuilder = [
    'AssetSoftwareInventory',
    'asset-view',
    'nmasset',
    'AllAssets',
    'AssetPatchDetail',
    'Client',
    'hoursworklogentry',
    'RequesterAssociation',
    'FeedbackSurveyResponse',
    'AssetRemoteSession',
    'offered-item'
  ];

  const getAttributeSelect = () => {
    switch (currentModule) {
      case 'AssetSoftwareInventory':
      case 'AssetPatchDetail':
      case 'AssetRemoteSession':
      case 'asset-view':
      case 'nmasset':
      case 'allassets':
        return onAssetViewAttributeSelect;
      case 'alert':
        return onAlertAttributeSelect;
      case 'patch':
      case 'patch-associated-asset':
        return onPatchViewAttributeSelect;
      case 'invoice':
        return onInvoiceViewAttributeSelect;
      case 'offered-item':
        return onOfferedItemAttributeSelect;
      case 'hoursworklogentry':
        return onWorklogEntrySelect;
      case 'Client':
      case 'RequesterAssociation':
        return onClientAttributeSelect;
      case 'FeedbackSurveyResponse':
        return onFilterSelect;
      case 'ticket':
      default:
        return onAttributeSelect;
    }
  };

  const getValueSearch = () => {
    switch (currentModule) {
      case 'AssetSoftwareInventory':
      case 'AssetPatchDetail':
      case 'AssetRemoteSession':
      case 'asset-view':
      case 'nmasset':
      case 'allassets':
        return onAssetViewAttributeValueSearch;
      case 'alert':
        return onAlertAttributeValueSearch;
      case 'patch':
      case 'patch-associated-asset':
        return onPatchViewAttributeValueSearch;
      case 'Client':
      case 'RequesterAssociation':
        return onClientAttributeSearch;
      case 'offered-item':
        return onOfferedItemAttributeSearch;
      case 'hoursworklogentry':
        return onWorklogEntrySearch;
      case 'FeedbackSurveyResponse':
        return onFilterSearch;
      case 'ticket':
      default:
        return onValueSearch;
    }
  };

  return (
    <AdvancedSearch
      {...props}
      currentModule={currentModule || 'ticket'}
      onAttributeSelect={getAttributeSelect()}
      onValueSearch={getValueSearch()}
      isNewBuilder={newBuilder.some((el) => el === currentModule)}
      fromReportBuilder
    />
  );
}

export default injectIntl(ReportQueryBuilderForm);
